import React from 'react';
import { FadeIn } from './FadeIn';
import { UserMinusIcon, TrendingDownIcon, UsersIcon, MicOffIcon } from 'lucide-react';
export function PainStories() {
  const pains = [{
    icon: <UserMinusIcon className="w-8 h-8 text-red-400" data-id="element-101" />,
    title: 'El alumno que deja de venir',
    text: 'Llevaba meses en tu clase. Le gustabas. Un día falta una semana, después dos, y ya no aparece más. No sabés por qué. No tenés forma de retenerlo. No tenés un sistema de seguimiento. Solo la sensación de que algo fallaste sin saber exactamente qué.'
  }, {
    icon: <TrendingDownIcon className="w-8 h-8 text-orange-400" data-id="element-102" />,
    title: 'La sala que no crece',
    text: 'Tenés 15 alumnos fijos desde hace 6 meses. La clase es buena pero no crece. No sabés cómo atraer gente nueva, no sabés cómo hacer que los actuales traigan amigos, y el gimnasio te sigue dando el mismo horario como si fuera un favor.'
  }, {
    icon: <MicOffIcon className="w-8 h-8 text-yellow-400" data-id="element-103" />,
    title: 'El cueing que no conecta',
    text: 'Decís las palabras correctas. Seguís el formato del release. Pero cuando mirás la sala, los alumnos están con cara de esfuerzo mecánico, no de experiencia. No están contigo. Están sobreviviendo la clase. Y vos lo sentís.'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-pump-gold" data-id="element-104" />,
    title: 'El instructor nuevo que te roba alumnos',
    text: 'Llegó hace tres meses. Tiene menos experiencia que vos. Pero tiene algo. Energía, carisma, una forma de hablar que engancha. Y lentamente algunos de tus alumnos empezaron a cambiar su horario al de él. Eso duele.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-pump-dark" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <FadeIn data-id="element-107">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-108">
            Y mientras tanto,{' '}
            <span className="text-red-400" data-id="element-109">pasan cosas que duelen.</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-110">
          {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-111">
              <div className="bg-pump-surface border border-pump-muted p-6 sm:p-8 rounded-2xl h-full hover:border-pump-gold/30 transition-colors" data-id="element-112">
                <div className="bg-pump-dark w-16 h-16 rounded-xl flex items-center justify-center mb-6 border border-pump-muted" data-id="element-113">
                  {pain.icon}
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-4" data-id="element-114">
                  {pain.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-115">{pain.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}